import React from "react";
import { skills } from "@/lib/data";
import { SectionHeader } from "@/components/About";

export default function Skills() {
    return (
        <section
            id="skills"
            data-testid="skills-section"
            className="relative py-24 md:py-32 border-t border-term-green/15"
        >
            <SectionHeader
                index="02"
                label="core competencies"
                command="ls ./skills/"
            />

            <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12">
                <div
                    data-testid="skills-grid"
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border border-term-green/20 bg-bg-surface/30"
                >
                    {skills.map((s, idx) => (
                        <SkillCard
                            key={s.group}
                            group={s.group}
                            items={s.items}
                            index={idx}
                        />
                    ))}
                </div>

                <div className="mt-8 font-mono text-xs text-ink-tertiary">
                    <span className="text-term-green">$</span> echo &quot;stack is what enables — outcomes are what matter.&quot;
                </div>
            </div>
        </section>
    );
}

function SkillCard({ group, items, index }) {
    return (
        <div
            data-testid={`skills-card-${index}`}
            className="group relative p-6 md:p-8 border-r border-b border-term-green/15 hover:bg-term-green/[0.04] transition-colors"
        >
            <div className="flex items-center justify-between mb-5">
                <span className="font-mono text-[10.5px] uppercase tracking-[0.24em] text-term-green">
                    // {group.toLowerCase()}
                </span>
                <span className="font-mono text-[10.5px] text-ink-tertiary tabular-nums">
                    [{String(index + 1).padStart(2, "0")}]
                </span>
            </div>

            <ul className="space-y-2 font-mono text-sm">
                {items.map((item) => (
                    <li
                        key={item}
                        className="flex items-baseline gap-2 text-ink-primary group-hover:translate-x-0.5 transition-transform"
                    >
                        <span className="text-term-green text-xs">▸</span>
                        <span>{item}</span>
                    </li>
                ))}
            </ul>

            {/* corner marker */}
            <span className="absolute top-2 right-2 w-2 h-2 border-t border-r border-term-green/40" />
            <span className="absolute bottom-2 left-2 w-2 h-2 border-b border-l border-term-green/40" />
        </div>
    );
}
